import React, { useState } from "react";
import styles from "../../../styles/pages/ProfilePage.module.scss";
import Icons from "../../../public/assets/svg";
import utility from "../../../utility/endpoints";
import DropDown from "../../listWithoutcheck";
import { BlobServiceClient } from "@azure/storage-blob";
import axios from "axios";
import Endpoints from "../../../utility/endpoints";
import SuccessModal from "../../../pages/successModal";
import Loader from "../../Loader"
import router from "next/router";
import endpoints from "../../../utility/endpoints";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const blobSasUrl =
  "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";

const blobSasUrlNew = endpoints.blobSasUrlNew;
//   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
const containerClient = blobServiceClient.getContainerClient("botstorevideo");
const { drupalIp } = utility;
const imagebaseUrl = `${endpoints.fetchBlobUrl}/`;
function index(props) {
  //console.log("props at profile", props);
  const {
    component: {
      content: { field_profile_image, field_user_profile_details },
    },
  } = props.data[0];

  // to convert labels into camelcase
  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const leadPlatformData = props.globalData.lead_platform_main_component[0];
  //console.log(leadPlatformData, "leadPlatformdata at user profile ");
  leadPlatformData.field_related_dropdown = "";
  const areaData = props.globalData.lead_platform_main_component[1];
  const subAreaData = props.globalData.lead_platform_main_component[2];

  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const countryData = props.globalData.cluster_main_component[2];
 
  const profileDrupalData = [
    leadPlatformData,
    clusterData,
    mcoData,
    countryData,
  ];
//console.log(profileDrupalData, "profileDrupalData")
  // saving bots camalcased label as value
  profileDrupalData.map((item) => {
    item.value = camelize(item.field_label);
  });

  let initialStates = {};
  let dropDownsInitialStates = {};
  // drupal

  profileDrupalData.map((item) => {
    if (
      item.field_input_type == "Related Dropdown" &&
      item.field_related_dropdown.length > 0
    ) {
      let fieldOptions = [];
      item.field_dropdown_option_component.map((item) => {
        fieldOptions = [...fieldOptions, ...item.field_options];
      });

      // item.field_options =
    }
  });

  profileDrupalData.map((item) => {
    initialStates[camelize(item.field_label)] = "";
    if (
      item.field_input_type == "Dropdown" ||
      item.field_input_type == "Related Dropdown"
    ) {
      dropDownsInitialStates[camelize(item.field_label)] = false;
    }
  });


  const intitailValues = {
    email: "",
    toUpdateUser: {
      image: "",
      name: "",
      cluster: "",
      country: "",
      leadPlatform: "",
      area: "",
    },
  };

  const [userApi, setUserApi] = React.useState(intitailValues);
  const [auth, setAuthData] = React.useState("");
  const [invalidFlag, setInvalidFlag] = useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [loader, setLoader] = useState(false)
  const [message, setMessage] = React.useState("Profile Updated successfully!");


  React.useEffect(() => {
    // get and set auth data

    let relatedDropdownToSet = {};

    //console.log(profileDrupalData, "firstBest");
    profileDrupalData.map((item) => {
      if (item.field_input_type == "Related Dropdown") {
        relatedDropdownToSet = {
          ...relatedDropdownToSet,
          [item.value]: { allValues: item.field_dropdown_option_component },
        };
      }
    });

    if (
      typeof window != undefined &&
      localStorage.getItem("auth") != undefined &&
      localStorage.getItem("auth") != ""
    ) {
      profileDrupalData.map((item) => {
        if (item.field_related_dropdown) {
          

          if (relatedDropdownToSet[camelize(item.field_related_dropdown)]) {
            let nowValues = _.get(
              relatedDropdownToSet[
                camelize(item.field_related_dropdown)
              ].allValues.filter(
                (innerItem) =>
                  innerItem.field_title ==
                  JSON.parse(localStorage.getItem("auth")).data[
                    item.value == "mCO" ? "personalMco" : item.value == "country" ? "personalCountry": item.value == "cluster" ? "personalCluster": item.value
                  ]
              )[0],
              "field_options",
              []
            );
            relatedDropdownToSet[
              camelize(item.field_related_dropdown)
            ].nowValues = nowValues;
          }
        }
      });

    

      let myCountries = []
      let myCountriesInfo = []
      //console.log(relatedDropdownToSet, "NEWSTATE")
      for (let i in relatedDropdownToSet.mCO.nowValues){
        let myCountriesToSet = []
        
        relatedDropdownToSet.country.allValues.map((countryItem, index) => {
           
         if(countryItem.field_title == relatedDropdownToSet.mCO.nowValues[i]) {
          //console.log(countryItem, "relatedDropdownnnsssCountry")
           myCountriesToSet = {country : countryItem, index}
         }
        })
     
     
        myCountries = [...myCountries, ...myCountriesToSet.country.field_options]
        myCountriesInfo = [...myCountriesInfo, myCountriesToSet]
      }
       
      relatedDropdownToSet.country.countryInfo = myCountriesInfo
      relatedDropdownToSet.country.nowValues = myCountries
    }

    setRelatedDropdowns({...relatedDropdownToSet});

 

    try {
      if (
        typeof window != undefined &&
        localStorage.getItem("auth") != undefined &&
        localStorage.getItem("auth") != ""
      ) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        //console.log(auth, "profileState");
        
        let myState = state
        myState.mCO = auth.personalMco;
        myState.country = auth.personalCountry
        myState.cluster = auth.personalCluster
        myState.leadPlatform = auth.personalLeadPlatform
        myState.area = auth.personalArea
        myState.subArea = auth.subArea
        
        setState({ ...state, ...auth, ...myState });
        //console.log(state, "profileState");
        setAuthData(auth);
        setProfileImage(auth.image);
        setUserApi({
          email: auth.email,
          toUpdateUser: {
            name: auth.name,
          },
        });
      }
    } catch (e) {
      //console.log("user update auth  error ----------------------");
      console.log("error  --", e);
      //console.log("user update error ----------------------");
    }
  }, []);

  const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);
  const [state, setState] = React.useState(initialStates);
  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );

  const [cantUpdateCluster, setCantUpdateCluster ] = React.useState(['firstGfcf', 'gfcf', 'gCad'])
  const [cantUpdateLeadPlatform, setCantUpdateLeadPlatform ] = React.useState(['gpmApprover', 'firstLevelGPMApprover'])

  const inputChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleDropDown = (item) => {
    //console.log(item, "item")
   
  // if( item == "cluster" || item == "mCO" || item == "country") {
  //   if (cantUpdateCluster.includes(auth.userType)) {
  //     return;
  //   }
  // }
  // else if (item == "leadPlatform") {
  //   if (cantUpdateLeadPlatform.includes(auth.userType)) {
  //     return;
  //   }
  // }
 
    
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
  };

  const [profileImageUrl, setProfileImageUrl] = React.useState(null);
  const [profileImage, setProfileImage] = React.useState("");
  const [imageType, setImageType] = React.useState(false);
  //
  const handleUserApi = async () => {
    let moveAhead = true;
    setLoader(true)
    const requiredFields = ["cluster", "mco", "country"];
    
    //console.log(state, "state of mind")
    //console.log(moveAhead, "moveahead");
    if (moveAhead) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      await setUserApi({
        ...userApi,
        email: userApi.email,
        toUpdateUser: {
          image: profileImageUrl,
          name: auth.name,
          cluster: state.cluster,
          leadPlatform: state.function,
          mco: state.mCO,
          subArea: state.subArea,
          country: state.country,
          area: state.subFunction,
        },
      });
      // }

      let payload = {
        email: auth.email,
        toUpdateUser: {
          image: profileImageUrl ? profileImageUrl : auth.image,
          name: auth.name,
          personalCluster: state.cluster,
          personalLeadPlatform: state.leadPlatform,
          personalCountry: state.country,
          personalArea: state.area,
          personalMco: state.mCO,
          personalSubArea: state.subArea,
        },
      };
      //console.log("state of mind", payload);
    
      
      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        await axios
          .put(`${Endpoints.baseUrl}/user/updateUserPersonalDetails`, payload, {
            headers: { Authorization: `${auth.accessToken}|${auth.email}` },
          })
          .then((res) => {
            if (res.data.code == 200) {
              //console.log(res.data, "response of update profileeeeeeeeeeeeeee");

              let presentAuth = JSON.parse(localStorage.getItem("auth"));
              res.data.data.accessToken = presentAuth.data.accessToken;
              //console.log("res.data", res.data);
              localStorage.setItem("auth", JSON.stringify(res.data));
              setSuccessModal(true);
              setLoader(false);
            } else if (res.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              // router.push("/login");
              setLoader(false)
              props.sessionTimeOutCheck(true);
            }
          });
      } else {
        setLoader(false)
        props.sessionTimeOutCheck(true);
      }
    } else {
      setInvalidFlag(true);
    }
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    //console.log(value, dropdownParent, haveRelated, "testing");
    let newState = state;
    if (haveRelated != null && haveRelated.length > 0) {
     
       newState[haveRelated] = ""
      //console.log(props.data, "props ka data idhar hi hai ");

   

      profileDrupalData.map((item, index) => {
        //console.log("value", item.field_label, "have related", haveRelated);
        if (camelize(item.field_label) == haveRelated) {
          //console.log(item, "pehle");
          //console.log(haveRelated, "as");
          if (
            camelize(item.field_related_dropdown) != null &&
            camelize(item.field_related_dropdown).length > 0
          ) {
            //  let newerState = state

             newState[camelize(item.field_related_dropdown)] = ""
          }
        }
      });
      
     
      //console.log(relatedDropdowns, "related Ka Khel");
      let selectedRelatedDropdown = relatedDropdowns;
      selectedRelatedDropdown[haveRelated].nowValues = selectedRelatedDropdown[
        haveRelated
      ].allValues.filter((item) => item.field_title == value)[0].field_options;

      //console.log(selectedRelatedDropdown, "relatedDropdownnnsss")

      if (dropdownParent == "cluster") {

      
      let myCountries = []
      let myCountriesInfo = []
      for (let i in selectedRelatedDropdown.mCO.nowValues){
        let myCountriesToSet = []
        
         selectedRelatedDropdown.country.allValues.map((countryItem, index) => {
           
         if(countryItem.field_title == selectedRelatedDropdown.mCO.nowValues[i]) {
          //console.log(countryItem, "relatedDropdownnnsssCountry")
           myCountriesToSet = {country : countryItem, index}
         }
        })
     
     
        myCountries = [...myCountries, ...myCountriesToSet.country.field_options]
        myCountriesInfo = [...myCountriesInfo, myCountriesToSet]
      }
       
      selectedRelatedDropdown.country.countryInfo = myCountriesInfo
      selectedRelatedDropdown.country.nowValues = myCountries
    }
    
  
    //console.log(dropdownParent, "SELECTEDcOUNTRY")

    

      
     
      setRelatedDropdowns({ ...selectedRelatedDropdown });
    }

    let myFlag = false

     if (dropdownParent == "country") { 
      myFlag = true
      //console.log(value, "SELECTEDcOUNTRYValue")
      //console.log(relatedDropdowns, "SELECTEDcOUNTRYRelated")
      var selectedCountryRightNow 
      relatedDropdowns.country.countryInfo.map((item, index) => { if (item.country.field_options.includes(value)){
      selectedCountryRightNow = item
      }})
     
      
     //console.log(relatedDropdowns.country.allValues[selectedCountryRightNow.index].field_title, "SELECTEDcOUNTRYMCO")
     }
    


    setDropdownState(dropDownsInitialStates);
    //console.log(newState , "NEWSTATE")
    setState({ ...newState, [dropdownParent]: value, mCO : myFlag ? relatedDropdowns.country.allValues[selectedCountryRightNow.index].field_title : state.mCO });
  };

  const nameInfo = field_user_profile_details.filter(
    (item) => item.field_label == "Full Name"
  );

  let parentArray = [];
  for (let i = 0; i < profileDrupalData.length; i++) {
    if (i % 2 == 0) {
      let twoItemArray = [];
      twoItemArray.push(profileDrupalData[i]);
      twoItemArray.push(profileDrupalData[i + 1]);
      parentArray.push(twoItemArray);
    }
  }

  const uploadImage = async (e) => {
    let file = e.target.files[0];
    //console.log(type, "exa")
    let fileName = e.target.files[0].name;
    let type = e.target.files[0].type;
    //setImageType(type)
    //console.log(type, "exa");

    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      let imageUrl = resp._response.request.url.split("?")[0].split("/");
      //console.log("image url  ----", imageUrl);
      imageUrl = imageUrl[imageUrl.length - 1];
      // console.log("exact url ---", imageUrl);
      //console.log(type, "exa")

      if (type == "image/png" || type == "image/jpeg" || type == "image/jpg") {
        setProfileImageUrl(imageUrl);
        setImageType(false);
        setProfileImage(imageUrl);
      } else {
        setProfileImageUrl(auth.image);
        setImageType(true);
        //  setProfileImage("");
      }
      // console.log(imageUrl,"imageUrl");
    } catch (error) {}
  };

  return (
    <div className={`${styles.container} container my-4`}>
      <div className={styles.profileDetailsWrapper}>
        <div className={styles.profileImgContainer}>
          <div className={styles.img}>
            {profileImage != "" &&
            profileImage != null &&
            profileImageUrl !== undefined ? (
              <img
                src={
                  profileImageUrl == null
                    ? `${imagebaseUrl}${auth.image}`
                    : `${imagebaseUrl}${profileImageUrl}`
                }
              />
            ) : (
              <div className={styles.dummy}>
                <img src="/assets/svg/userDummy.png" />
              </div>
            )}

           
            <div className={styles.inputGroup}>
            <label style = {{cursor: "pointer"}}  for="file-input">
              <img className ={styles.uploadIcon} src = "/assets/svg/camera.png"/>
             </label>           
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                style = {{display:"none"}}
                id="file-input"
                onChange={uploadImage}
              />
              {/* <span className={`${styles.fileName} ${styles.uploading}`}>No File Chosen</span> */}
            </div>
          </div>
          {imageType ? (
            <div className={styles.imgerror}>Wrong image type selected !!!</div>
          ) : null}
          <div className={styles.name}>
            <p>{userApi.toUpdateUser.name}</p>
          </div>
        </div>

        <div className={styles.detailsSec}>
          <div className={styles.row} key={index}>
            <div className={`${styles.formGroup} `}>
              <label>
                <span>Full Name</span>
              </label>

              <input
                type="text"
                defaultValue={userApi.toUpdateUser.name}
                disabled={true}
              />
            </div>

            <div className={`${styles.formGroup} `}>
              <label>
                <span>Email ID</span>
              </label>

              <input type="text" defaultValue={userApi.email} disabled={true} />
            </div>
          </div>

          {parentArray.map((parentItem, index) => (
            <div className={styles.row} key={index}>
              {parentItem.map((item, index) => {
               
               if ( item.field_form_field_title  != "MCO")
                return (
                  <div className={styles.colFirst} key={index}>
                    <div className={styles.row}>
                      <div className={styles.formGroup}>
                        <label className={styles.label}>
                          <span>
                            {item.field_label}

                            
                          </span>
                          <span className={styles.required}>
                            {invalidFlag
                              ? state[item.value] === "" ||
                                //state[requiredFields[i]] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == [] ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null
                                ? "Required Field"
                                : null
                              : null}
                          </span>

                          {/* error message */}
                        </label>
                        <p
                          className={`${styles.input}`}
                          onClick={() => {
                            handleDropDown(item.value);
                          }}
                        >
                          <span className={styles.left}>
                            {state[item.value] == null ||
                            state[item.value] == "undefined" ||
                            state[item.value] === ""
                              ? //item.field_label == "Country"
                                item.field_input
                              : state[item.value]}
                          </span>
                          
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span> 
                        </p>
                        {dropDownState[item.value] == true ? (
                          <DropDown
                            dropdownParent={item.value}
                            values={
                              item.field_input_type == "Related Dropdown"
                                ? relatedDropdowns[item.value].nowValues !=
                                  undefined
                                  ? relatedDropdowns[camelize(item.field_label)]
                                      .nowValues
                                  : ["No parent Selected"]
                                : item.field_options
                            }
                            getDropdownValue={gotDropDownValue}
                            haveRelated={camelize(item.field_related_dropdown)}
                            param="profile"
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}

          <div className={styles.row}>
            <div className={styles.saveDetails} >
              <span className={styles.btn} onClick={handleUserApi}>Save Details</span>
            </div>
          </div>
        </div>
        {loader? <Loader/>
        :successModal ? (
          <SuccessModal
            setSuccessModal={setSuccessModal}
            title={"Profile"}
            message={message}
          />
        ) : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
